// extracted by mini-css-extract-plugin
export var grayBg = "Header-module--gray-bg--6649e";
export var iconContainer = "Header-module--icon-container--dc342";
export var stages = "Header-module--stages--a8fda";
export var transparentBg = "Header-module--transparent-bg--a52d8";
export var verticalGradientBg = "Header-module--vertical-gradient-bg--fbe65";
export var whiteBg = "Header-module--white-bg--76e9e";